import http from "./http.js";

async function createCurrency(resource, entity) {
  const response = await http.post(`isg-logistics/${resource}`, entity);
  return response;
}

export {
  createCurrency,
};